export default __webpack_public_path__ + "static/media/eye-open.388836fe.svg";